import { apiClient } from './apiClient'

export async function getVapidPublicKey(): Promise<string> {
  const result = await apiClient.get<{ publicKey: string }>('/api/notifications/vapid-public-key')
  return result.publicKey
}

export async function subscribeToPush(subscription: PushSubscription): Promise<void> {
  const key = subscription.getKey('p256dh')
  const auth = subscription.getKey('auth')
  if (!key || !auth) throw new Error('Missing push subscription keys')

  await apiClient.post('/api/notifications/subscribe', {
    endpoint: subscription.endpoint,
    p256dh: arrayBufferToBase64Url(key),
    auth: arrayBufferToBase64Url(auth),
  })
}

export async function unsubscribeFromPush(endpoint: string): Promise<void> {
  await apiClient.post('/api/notifications/unsubscribe', { endpoint })
}

export async function getNotificationsEnabled(): Promise<boolean> {
  const result = await apiClient.get<{ enabled: boolean }>('/api/notifications/enabled')
  return result.enabled
}

export async function setNotificationsEnabled(enabled: boolean): Promise<void> {
  await apiClient.put('/api/notifications/enabled', { enabled })
}

function arrayBufferToBase64Url(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer)
  let binary = ''
  for (const byte of bytes) {
    binary += String.fromCharCode(byte)
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}
